module.exports = __webpack_public_path__ + "img/flag.3b3ba750.gif";